// extracted by mini-css-extract-plugin
export default {"tabBar":"tabbar_tabBar__CtDv2","active":"tabbar_active__lX3Fq","titleBar":"tabbar_titleBar__Dcb6u","tabBarContainer":"tabbar_tabBarContainer__4910m"};